<div class="ap-browser-selector-skeleton">
    <ap-paragraph-skeleton [rows]="2"></ap-paragraph-skeleton>
    <ap-input-skeleton></ap-input-skeleton>
    <ap-input-skeleton></ap-input-skeleton>
    <ap-button-skeleton></ap-button-skeleton>
</div>
